/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */

import { ERROR_MESSAGES } from 'utils/constants/toastMessages';
import docIcon from '../../../static/images/docIcon.svg';
import deleteIcon from '../../../static/images/deleteIcon.svg';
import uploadIcon from '../../../static/images/upload.svg';
import viewIcon from '../../../static/images/view.svg';

// Libraries
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import './index.scss';

const UploadWrapper = styled.div`
    max-width: 100%;
    height: 56px;
    display: flex;
`;

const UploadFieldWrapper = styled.div`
    background: ${props =>
        props.isValuePresent ? 'rgba(251, 251, 251, 1)    ' : '#fff'};
    border-radius: 8px;
    border-style: solid;
    border-color: rgba(195, 193, 191, 0.72);
    border-width: 1px;
    width: 100%;
    height: 46px;
`;

const UploadField = styled.input`
    border-radius: 8px;
    width: 0;
    height: 0;
    font-size: 14px;
    opacity: 0;
`;

const UploadLabel = styled.input`
    border-radius: 8px;
    width: 0;
    height: 0;
    font-size: 14px;
    opacity: 0;
`;

const Label = styled.label`
    color: #d2d3d5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 20px;
`;

const Icon = styled.img`
    width: ${props => (props.size === 'small' ? '20px' : '30px')};
    height: ${props => (props.size === 'small' ? '20px' : '30px')};
    margin-right: ${props => (props.marginRight ? props.marginRight : 0)};
    cursor: ${props => (props.isActionIcon ? 'pointer' : '')};
`;

const ErrorWrapper = styled.span`
    color: #f00;
    display: block;
    font-size: 12px;
    margin: 8px 0;
    /* text-transform: capitalize; */
`;

const InfoElementWrapper = styled.span`
    display: block;
    font-size: 12px;
    margin: 4px 0 0;
`;

const UploadElement = props => {
    const {
        id,
        prefixIconUrl,
        prefixIconWidth = '12px',
        prefixIconHeight = '12px',
        prefixPositionX = '18px',
        prefixPositionY = '14px',
        name,
        type,
        placeholder,
        wrapperClass,
        borderRadius,
        error,
        input,
        handleChange,
        handleBlur,
        handleFocus,
        handleReadOnlyClick,
        readOnly,
        disabled = false,
        hideErrors,
        meta,
        infoElement,
        accept,
        uploadImageAndGetURL,
        allowedExtensions,
        docUrl,
        handleView,
        labelName,
        MLEerrorMessage,
        MaxFileSize
    } = props;
    
    // check for empty docUrl
    const filteredDocUrl = Array.isArray(docUrl) && docUrl.length === 0 ? null : docUrl ?? null;
    
    const [docUrlState, setDocUrlState] = useState(filteredDocUrl);

    useEffect(() => {
        setDocUrlState(filteredDocUrl);
    }, [docUrl]);

    const onDeleteClick = () => {
        setDocUrlState(null);
        input.onChange(null);
        setFileName(null);
        handleChange(input.name, '');
    };

    const inputRef = useRef(null);

    const [fileName, setFileName] = useState(null);

    async function handleInputChange(event) {
        event.preventDefault();
        const files = event.target.files[0];
        if (files) {
            const fileName = files.name;
            const fileExtension = fileName
                .split('.')
                .pop()
                .toLowerCase();

            if (allowedExtensions.includes(fileExtension)) {
                
                if(MaxFileSize != null && files?.size >= 1024 * 1024 * MaxFileSize){
                    toast.info(`File Size should not exceed more than ${MaxFileSize}MB`)
                }
                else{
                    const imageUrl = await uploadImageAndGetURL(files, input.name);
                    input.onChange(files);
                    setFileName(fileName);
                    handleChange(input.name, imageUrl);
                }
            } else {
                MLEerrorMessage ? toast.info(MLEerrorMessage) : toast.info(ERROR_MESSAGES.ONLY_IMAGE_FILE);
            }
        }
    }

    const uploadComponent = (
        <UploadField
            type={typeof input.value === 'string' ? 'text' : 'file'}
            name={name}
            id={id}
            placeholder={placeholder}
            onChange={handleInputChange}
            onBlur={null}
            onFocus={null}
            prefixIconUrl={prefixIconUrl}
            prefixIconWidth={prefixIconWidth}
            prefixIconHeight={prefixIconHeight}
            prefixPositionX={prefixPositionX}
            prefixPositionY={prefixPositionY}
            disabled={disabled}
            readOnly={readOnly}
            onClick={event => {
                event.target.files = null;
                event.target.value = null;
            }}
            showSubmitButton={null}
            ref={inputRef}
            accept={accept}
        />
    );
    let uploadMarginUpdateClass = (!hideErrors && (error || (meta && meta.error && meta.touched))) ? 'update-width' : 'info-element';
    return (
        <UploadWrapper
            className={`input-container ${wrapperClass || ''}${
                error || (meta && meta.error && meta.touched) ? ' error' : ''
            }`}
        >
            <UploadFieldWrapper
                borderRadius={borderRadius || '2px'}
                isValuePresent={docUrlState ? true : false}
                error={error || (meta && meta.error && meta.touched)}
            >
                <Label
                    htmlFor={docUrlState ? null : id}
                    isValuePresent={docUrlState ? true : false}
                >
                    {docUrlState ? (
                        <>
                            <div className='docUploadDiv'
                                style={{
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Icon src={docIcon} size="small" alt="doc" />
                                <span
                                    style={{
                                        color: '#707070',
                                        paddingLeft: 10,
                                    }}
                                >
                                    {labelName
                                        ? labelName
                                        : fileName
                                        ? fileName
                                        : input.name}
                                </span>
                            </div>
                            <div className="icon-container">
                                <Icon
                                    src={viewIcon}
                                    marginRight="10px"
                                    size="small"
                                    isActionIcon
                                    onClick={() => handleView(docUrlState)}
                                    alt="view"
                                />
                            {!disabled && (
                                <Icon
                                    src={deleteIcon}
                                    size="small"
                                    isActionIcon
                                    onClick={() => onDeleteClick()}
                                    alt="delete"
                                />
                            )}
                            </div>
                        </>
                    ) : (
                        <>
                            <span>{placeholder}</span>
                            <Icon src={uploadIcon} alt="upload" />
                        </>
                    )}
                </Label>
                {uploadComponent}
            </UploadFieldWrapper>

            {!hideErrors && (error || (meta && meta.error && meta.touched)) && (
                <ErrorWrapper className="error-message">
                    {error || meta.error}
                </ErrorWrapper>
            )}
            {infoElement && (
                <InfoElementWrapper className={`info-element ${uploadMarginUpdateClass}`}>{infoElement}</InfoElementWrapper>
            )}
        </UploadWrapper>
    );
};

UploadElement.propTypes = {
    className: PropTypes.string,
    defaultSelected: PropTypes.string,
    handleChange: PropTypes.func,
    labelField: PropTypes.string,
    options: PropTypes.array,
    valueField: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object,
    wrapperClass: PropTypes.string,
};

export default UploadElement;
